import type { IconNode } from '../types';

/**
 * @name glasses-sun
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMi4xNiAxNC4yIDMuMS03LjRDNS43IDUuOCA2LjggNSA4IDUiIC8+CiAgPHBhdGggZD0iTTQgMTNhMiAyIDAgMCAwLTIgMnYxYzAgMS43IDEuMyAzIDMgM2gxYzMuMyAwIDYtMi43IDYtNiAwIDMuMyAyLjcgNiA2IDZoMWMxLjcgMCAzLTEuMyAzLTN2LTFhMiAyIDAgMCAwLTItMloiIC8+CiAgPHBhdGggZD0ibTIxLjgzIDE0LjItMy4xLTcuNEMxOC4zIDUuOCAxNy4yIDUgMTYgNSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/glasses-sun
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const glassesSun: IconNode = [
  ['path', { d: 'm2.16 14.2 3.1-7.4C5.7 5.8 6.8 5 8 5', key: '5gjrv1' }],
  [
    'path',
    {
      d: 'M4 13a2 2 0 0 0-2 2v1c0 1.7 1.3 3 3 3h1c3.3 0 6-2.7 6-6 0 3.3 2.7 6 6 6h1c1.7 0 3-1.3 3-3v-1a2 2 0 0 0-2-2Z',
      key: '1d2b14',
    },
  ],
  ['path', { d: 'm21.83 14.2-3.1-7.4C18.3 5.8 17.2 5 16 5', key: 'wlqo5c' }],
];

export default glassesSun;
